import { useMemo } from 'react'
import get from 'lodash/get'
import { FormikProps } from 'formik'
import { IPackInput } from '../../types/pack'
import { isEditionPublished } from '../../services/packForm'
import {
  getObjectForTracking,
  objectsAreNotEqual,
  editionFieldOfInterest,
  createLanguageTransform,
} from '../../services/packForm'

export const useEditionTrackingChanges = (
  formikProps: FormikProps<IPackInput>,
  index: number
): boolean =>
  useTrackingChanges(
    get(formikProps.values, `editions.${index}`, {}),
    get(formikProps.initialValues, `editions.${index}`),
    editionFieldOfInterest,
    {
      language: createLanguageTransform(formikProps.values.language),
    }
  )

export const useTrackingChanges = (
  formValue: object,
  initFormValue: object,
  fieldsOfInterest: string[],
  transform?: object,
  useLodashIsEqual = false
): boolean =>
  useMemo(
    () =>
      fieldsOfInterest.length
        ? objectsAreNotEqual(
            getObjectForTracking(initFormValue, fieldsOfInterest, transform),
            getObjectForTracking(formValue, fieldsOfInterest, transform),
            useLodashIsEqual
          )
        : objectsAreNotEqual(initFormValue, formValue, useLodashIsEqual),
    [formValue, initFormValue, fieldsOfInterest, transform, useLodashIsEqual]
  )

export const useShowRevisionCopyAction = (
  { errors, values: { editions } }: FormikProps<IPackInput>,
  index: number
): boolean =>
  useMemo(
    () =>
      ![
        `editions.${index}.editStatus`,
        `editions.${index}.releaseNote`,
      ].some((name) => get(errors, name, false)) &&
      !!editions &&
      editions.filter(isEditionPublished).length > 1,
    [errors, editions, index]
  )
